import assignOffsetPagination from "@/schemas/assignOffsetPagination";
import QuestionSchema from "@apps/reviews/schemas/QuestionSchema";

const QuestionsListResponseSchema = assignOffsetPagination(QuestionSchema);
export default QuestionsListResponseSchema;
